import { render, staticRenderFns } from "./addItemsRow.vue?vue&type=template&id=625a7780&"
import script from "./addItemsRow.vue?vue&type=script&lang=js&"
export * from "./addItemsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports